import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { CHAT_MOBILE_COLORS } from '@/constants/residents/mobile/chatColors';
import { SVG_COMPONENTS } from '@/assets/admin';

const CloseIcon = SVG_COMPONENTS.CANCEL_X;

interface ChatConversationHeaderProps {
  subject: string;
  createdAt?: string;
  onClose: () => void;
}

/**
 * Header component for conversation detail screen
 * Displays subject, creation date, and close button
 */
export const ChatConversationHeader: React.FC<ChatConversationHeaderProps> = ({
  subject,
  createdAt,
  onClose,
}) => {
  return (
    <View style={styles.container}>
      <View style={styles.textContainer}>
        <Text style={styles.subject} numberOfLines={2}>
          {subject}
        </Text>
        {createdAt && (
          <Text style={styles.createdAt}>
            Created {createdAt}
          </Text>
        )}
      </View>
      <TouchableOpacity
        style={styles.closeButton}
        onPress={onClose}
        hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      >
        <CloseIcon width={16} height={16} color={CHAT_MOBILE_COLORS.textMuted} />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingHorizontal: 24,
    paddingTop: 20,
    paddingBottom: 18,
    borderBottomWidth: 1,
    borderBottomColor: CHAT_MOBILE_COLORS.divider,
    backgroundColor: CHAT_MOBILE_COLORS.cardBackground,
  },
  textContainer: {
    flex: 1,
    gap: 2,
    marginRight: 16,
  },
  subject: {
    fontSize: 18,
    fontWeight: '600',
    color: CHAT_MOBILE_COLORS.textPrimary,
    lineHeight: 27,
  },
  createdAt: {
    fontSize: 12,
    fontWeight: '300',
    color: CHAT_MOBILE_COLORS.textPlaceholder,
    lineHeight: 18,
  },
  closeButton: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 4,
  },
});

export default ChatConversationHeader;
